import { render, staticRenderFns } from "./Stakeholders.vue?vue&type=template&id=505d4619"
import script from "./Stakeholders.vue?vue&type=script&lang=js"
export * from "./Stakeholders.vue?vue&type=script&lang=js"
import style0 from "./Stakeholders.vue?vue&type=style&index=0&id=505d4619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports